import request from '@/utils/request'
// 查询销售订单数据列表
export function saleOrderList(params) {
  return request({
    url: 'admin/marketOrder/qlMarketList',
    method: 'get',
    params: params
  })
}

//查询销售订单详情数据
export function saleOrderDetail(params) {
  return request({
    url: 'admin/marketOrder/queryMarketOrderRecordByCardId',
    method: 'get',
    params: params
  })
}

// 修改销售订单数据
export function updateSaleOrder(data) {
  return request({
    url: '/admin/marketOrder/saveMarket',
    method: 'post',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/saleOrder.js